import { useTranslation } from "react-i18next";
import { CreditCard, Wallet } from "lucide-react";
import { useCheckInSend } from "../context";
import { useAudio } from "../../../../../lib/use-audio";
import { Tile } from "../../../components/Tile";
import { KioskStep } from "../../../../../components/kiosk-step";

/**
 * Insurance selection step: statutory vs private/self-pay. Two content-sized
 * choice tiles (KC-23); the tile tap is the action, so there is no footer
 * primary.
 *
 * @since 1.0.0
 * @example
 * ```tsx
 * <InsuranceSelectionStep />
 * ```
 */
export function InsuranceSelectionStep() {
  const { t } = useTranslation();
  const send = useCheckInSend();

  // Play audio on mount
  useAudio("checkIn-insuranceSelection");

  return (
    <KioskStep
      width="default"
      title={t("self-service.check-in.insurance-selection.title")}
      lead={t("self-service.check-in.insurance-selection.subtitle")}
    >
      <div className="grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2">
        <Tile
          tone="blue-ink"
          className="min-h-44"
          data-testid="insurance-gkv"
          name={t("self-service.check-in.insurance-selection.gkv")}
          desc={t("self-service.check-in.insurance-selection.gkv-description")}
          icon={<CreditCard />}
          onClick={() => send({ type: "SELECT_GKV" })}
        />
        <Tile
          tone="sky-subtle"
          className="min-h-44"
          data-testid="insurance-pkv"
          name={t("self-service.check-in.insurance-selection.pkv")}
          desc={t("self-service.check-in.insurance-selection.pkv-description-v2")}
          icon={<Wallet />}
          onClick={() => send({ type: "SELECT_PKV_OR_SELFPAY" })}
        />
      </div>
    </KioskStep>
  );
}
